'use strict';

import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import Stepper from 'react-stepper-horizontal';
import { Navbar, Nav, Container, Button, Dropdown, Row, Col, CardGroup, CardDeck, Card } from 'react-bootstrap';
import CustomHeader from '../components/Header'
import Swal from 'sweetalert2/dist/sweetalert2.js';
import "../css/Managehssestyle.css";
// import Stepper from 'react-stepper-wizard'
import VehicleGroupBox from "../components/VehicleGroupBox";
import VehicleGroupBoxItem from "../components/VehicleGroupBoxItem";
import MapContainer from '../components/GoogleMapsNew'
import SelectionTable from '../components/Tables/SelectionTable'
import DatePicker from 'react-date-picker';

import '../css/Manage.css'
import Select from 'react-select'

import HeadingBox from '../components/HeadingBox'

import axiosConfig from '../config/axiosConfig'

const customStyles = {
    option: (provided, state) => ({
        ...provided,
        color: state.isSelected ? 'black' : 'black',
        backgroundColor: state.isSelected ? '#7367f0' : 'white'
    }),
    control: (provided) => ({
        ...provided,
        borderRadius: '20px',
        borderColor: '#7367f0'

    })
}

const customStyles2 = {
    option: (provided, state) => ({
        ...provided,
        color: state.isSelected ? 'black' : 'black',
        backgroundColor: state.isSelected ? '#7367f0' : 'white'
    }),
    control: (provided) => ({
        ...provided,
        borderRadius: '20px',
        borderColor: '#7367f0'

    })
}

const inputSMSOptions = new Promise((resolve) => {
    setTimeout(() => {
        resolve({
            '03331234567': '03331234567',
            '03109876541': '03109876541',
            'both': 'Both'
        })
    }, 1000)
})

const inputMileageOptions = new Promise((resolve) => {
    setTimeout(() => {
        resolve({
            'PKR': 'PKR',
            'Liters': 'Liters'

        })
    }, 1000)
})

const inputEmailOptions = new Promise((resolve) => {
    setTimeout(() => {
        resolve({
            'shariq@altpay.biz': 'shariq@altpay.biz',
            'safee@altpay.biz': 'safee@altpay.biz',
            'both': 'Both'
        })
    }, 1000)
})

const currentDate = new Date();

class ManageDeclineTransaction extends Component {
    constructor() {
        super();
        this.state = {
            steps: [
                {
                    title: 'Step One',
                    onClick: (e) => {
                        e.preventDefault()
                        console.log('onClick', 1)
                    }
                },
                {
                    title: 'Step Two',
                    onClick: (e) => {
                        e.preventDefault()
                        console.log('onClick', 2)
                    }
                },
                {
                    title: 'Step Three',
                    onClick: (e) => {
                        e.preventDefault()
                        console.log('onClick', 2)
                    }
                }
            ],



            data: [
                { "id": "105001", "Amount": "540", "Site": "Marine Drive", "Quantity": "4.82", "Time": "13-April-2021", "Code": "05", "Description": "DO NOT HONOUR", "Product": "Shell Super", "Price": "112" },
                { "id": "105002", "Amount": "540", "Site": "Marine Drive", "Quantity": "4.82", "Time": "13-April-2021", "Code": "05", "Description": "DO NOT HONOUR", "Product": "Shell Super", "Price": "112" },
                { "id": "105003", "Amount": "540", "Site": "Marine Drive", "Quantity": "4.82", "Time": "13-April-2021", "Code": "05", "Description": "DO NOT HONOUR", "Product": "Shell Super", "Price": "112" },
                { "id": "105004", "Amount": "540", "Site": "Marine Drive", "Quantity": "4.82", "Time": "13-April-2021", "Code": "05", "Description": "DO NOT HONOUR", "Product": "Shell Super", "Price": "112" },
                { "id": "105005", "Amount": "540", "Site": "Marine Drive", "Quantity": "4.82", "Time": "13-April-2021", "Code": "05", "Description": "DO NOT HONOUR", "Product": "Shell Super", "Price": "112" },
                { "id": "105006", "Amount": "540", "Site": "Marine Drive", "Quantity": "4.82", "Time": "13-April-2021", "Code": "05", "Description": "DO NOT HONOUR", "Product": "Shell Super", "Price": "112" },
            ],
            columns: [
                { "HeaderText": "Transaction ID", "MappingColomn": "id" },
                { "HeaderText": "Transaction Amount", "MappingColomn": "Amount" },
                { "HeaderText": "Site", "MappingColomn": "Site" },
                { "HeaderText": "Quantity", "MappingColomn": "Quantity" },
                { "HeaderText": "Time", "MappingColomn": "Time" },
                { "HeaderText": "Status Code", "MappingColomn": "Code" },
                { "HeaderText": "Status Description", "MappingColomn": "Description" },
                { "HeaderText": "Product", "MappingColomn": "Product" },
                { "HeaderText": "Price", "MappingColomn": "Price" }
            ],

            currentStep: 0,

            groups: [],
            vrnOptions: [],

            fromDate: new Date(currentDate.getFullYear(), currentDate.getMonth(), 1), //new Date(date.getFullYear(), date.getMonth(), 1);
            toDate: new Date()
        };
        this.onClickNext = this.onClickNext.bind(this);
        this.onClickPrevious = this.onClickPrevious.bind(this)


        this.changeGroup = this.changeGroup.bind(this)



    }

    componentDidMount() {
        const data = {
            UserBranchID: this.props.data.selectedBranchId,
        }
        axiosConfig.post('Portal/GetVRNGroupMapping', data)
            .then(res => {
                for (var i = 0; i < res.data.groupVRN.length; i++) {
                    this.setState(prevState => ({
                        groups: [...prevState.groups, { value: res.data.groupVRN[i].groupID, label: res.data.groupVRN[i].groupName, vrn: res.data.groupVRN[i].vrnModel }]
                    }))
                }
            }
            )
            .catch(function (error) {
            }
            );
    }

    changeGroup(selectedOption) {
        console.log(selectedOption)
        var tmpArray = []
        console.log(tmpArray)

        this.setState({
            vrnOptions: []
        }, function () {
            let tmpArray = this.state.groups.find(groupid => groupid.value === selectedOption.value)
            tmpArray.vrn.map((el, index) => {

                this.setState(prevState => ({
                    vrnOptions: [...prevState.vrnOptions,
                    {
                        value: el.mappingID,
                        label: el.vrn
                    }]
                }))

            })
        });
    }

    handleSubmit = (e) => {
        e.preventDefault();
    };

    onClickNext() {
        console.log(this.state.currentStep)
        if (this.state.currentStep < 2)
            this.setState({
                currentStep: this.state.currentStep + 1,
            });
    }

    onClickPrevious() {
        console.log(this.state.currentStep)
        if (this.state.currentStep > 0)
            this.setState({
                currentStep: this.state.currentStep - 1,
            });
    }

    render() {
        const { steps, currentStep } = this.state;
        const buttonStyle = { background: '#E0E0E0', width: 200, padding: 16, textAlign: 'center', margin: '0 auto', marginTop: 32 };

        return (

            <Container>


                <HeadingBox title="You can only view Declined Transactions for those Shell Cards that are part of a Combination and have been mapped to a Vehicle"></HeadingBox>


                <CardDeck className="text-left">
                    <Card>
                        <Card.Title className="px-3 mt-3">
                            Manage Declined Transactions
                            </Card.Title>
                        <Card.Body>

                            <Stepper
                                steps={steps}
                                activeStep={currentStep}
                                activeColor="#ffd500"
                                defaultBarColor="#ffd500"
                                completeColor="red"
                                // completeColor="red"
                                completeBarColor="#ffd500"
                                defaultBorderColor="green"
                            />


                            {currentStep === 0 && (
                                <>


                                    <div className="d-flex align-items-center justify-content-center" style={{ height: 'calc(20vh - 20px)' }}>




                                        <div className="col-sm-3 col-12">
                                            <div>Please Select Vehicle Group</div>
                                        </div>

                                        <div className="col-sm-3 col-12">
                                            <Select className=""
                                                options={this.state.groups}
                                                styles={customStyles}
                                                onChange={this.changeGroup}>

                                            </Select>

                                        </div>

                                    </div>

                                </>

                            )}


                            {currentStep === 1 && (
                                <>


                                    <div className="d-flex align-items-center justify-content-center" style={{ height: 'calc(20vh - 20px)' }}>
                                        <div className="col-sm-3 col-12">
                                            <div className="iconspacing-Nav">Please Select Vehicles</div>
                                        </div>

                                        <div className="col-sm-3 col-12">
                                            <Select className=""
                                                options={this.state.vrnOptions}
                                                styles={customStyles}>

                                            </Select>

                                        </div>

                                    </div>

                                </>

                            )}

                            {currentStep === 2 && (

                                <div className="mt-4">

                                    <div className="d-flex justify-content-center">
                                        <span className="align-middel">From the Date</span>
                                        <DatePicker
                                            //onChange={onChange}
                                            value={this.state.fromDate}
                                        />

                                        <span className="align-middle"> &nbsp;&nbsp;To</span>
                                        <DatePicker
                                            //onChange={onChange}
                                            value={this.state.toDate}
                                        />
                                    </div>

                                    <div>

                                        <HeadingBox title=" Please select the Decline transactions you want to include"></HeadingBox>
                                    </div>

                                    <SelectionTable data={this.state.data} columns={this.state.columns} />

                                </div>


                            )}

                            <div >
                                <div class="pull-left"><Button className="btn-shell" variant="warning" onClick={this.onClickPrevious}>Previous</Button></div>
                                <div class="pull-right"><Button className="btn-shell" variant="warning" onClick={this.onClickNext}>Next</Button></div>
                            </div>




                        </Card.Body>
                    </Card>
                </CardDeck >
            </Container >
        );
    }
};

export default ManageDeclineTransaction